import { Select } from '@/components/selects/Select'
import { Typography } from '@/components/Typography'
import { EmailReportIntervalType, I18N_PREFIX } from '@/pages/EmailReport/EmailReport'
import { DeliveryDaySelect } from '../DeliveryDaySelect'

import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

interface IntervalSelectComponentProps {
  value?: {
    interval: EmailReportIntervalType
    day: number | null
  }
  onChange?: (value: { interval?: EmailReportIntervalType; day?: number | null }) => void
  intervalOptions: Array<{ label: string; value: EmailReportIntervalType }>
}

export function IntervalSelectComponent({
  value,
  onChange,
  intervalOptions,
}: IntervalSelectComponentProps) {
  const { t } = useTranslation()

  function onIntervalChange(interval: EmailReportIntervalType) {
    if (interval === EmailReportIntervalType.daily) {
      onChange?.({
        interval,
        day: null,
      })

      return
    }

    onChange?.({
      interval,
      day: 1,
    })
  }

  return (
    <>
      <Typography.Text>
        {t(`${I18N_PREFIX}.form.sections.general.frequency.prefix`)}
      </Typography.Text>
      <Select
        value={value?.interval}
        onChange={onIntervalChange}
        options={intervalOptions}
        className={styles.intervalSelect}
      />
      <DeliveryDaySelect
        value={value?.day}
        onChange={(day: number | null) => {
          onChange?.({
            day,
            interval: value?.interval,
          })
        }}
        selectedInterval={value?.interval}
      />
    </>
  )
}
